<template>
  <div class="region-map">
    <div class="map">
      <div id="region_map" class="map-echarts" ref="regionMapRef"></div>
      <!-- <div >终端累计使用次数</div> -->
      <!-- <img :src="require('@/assets/images/sydataboard/title-bg.png')" alt=""> -->
    </div>
    <div class="active-school-rank-top">
      <div class="title">终端累计使用次数</div>
      <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
      <div class="" style="display: flex;margin-top: 10px;color: #FFFFFF;font-size: 39px;display: flex;justify-content: flex-end;">
        <div class="number">5</div>
        <div class="number">3</div>
        <div class="number">6</div>
        <div>,</div>
        <div class="number">4</div>
        <div class="number">2</div>
        <div class="number">4</div>
        <div>,</div>
        <div class="number">3</div>
        <div class="number">0</div>
        <div class="number">5</div>
      </div>
      <div class="dynamicList">
        <div class="list">
          <div v-for="item in dynamic" class="item" :style="{ marginLeft: (Math.random() * 30) + '%' }">
            <span class="red-text">{{ item.operation.slice(0, 19) }}</span>
            <span>{{ item.operation.slice(19) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getRegionSchoolInfomation,
  getNextRegionSchoolInfomation,
  queryBaseRegionCoordinateByRegionCode,
} from "@/service/api";
export default {
  name: 'region-map',
  components: {},
  data() {
    return {
      areaParams: {
        provinceCode: '安徽省',
        provinceName: '340000',
        districtCode: '340104',
        districtName: '蜀山区',
        cityCode: '340100',
        cityName: '合肥市'
      },
      schoolNum: 0,
      classNum: 0,
      studentNum: 0,
      teacherNum: 0,
      geoCoordMap: {},
      regionId: "5ee5b923177a45aeb8133caaed684003",
      typeInfo: null,
      dynamic: [{
        "operation_time": "2022-12-01 21:46:13.000",
        "id": "adfa0f7a9b74429ab836d7f23f0f2b7b",
        "type": 2,
        "operation": "2022-12-01 21:46:13 洪梅教师上传了一份资源",
        "realname": "洪梅"
      }, {
        "operation_time": "2022-12-01 00:05:59.000",
        "id": "4f747277de5143608e28acd2611e24c7",
        "type": 2,
        "operation": "2022-12-01 00:05:59 洪梅教师上传了一份资源",
        "realname": "洪梅"
      }, {
        "operation_time": "2022-02-13 21:07:43.000",
        "id": "388663336",
        "type": 2,
        "operation": "2022-02-13 21:07:43 田婧教师上传了一份资源",
        "realname": "田婧"
      }, {
        "operation_time": "2022-02-13 14:43:28.000",
        "id": "b8a071511eb84d5f829e76a7be26a7b9",
        "type": 1,
        "operation": "2022-02-13 14:43:28 尤圣昕教师布置了一份高中物理作业",
        "realname": "尤圣昕"
      }, {
        "operation_time": "2022-02-13 14:22:46.000",
        "id": "de7a3b8d80ca4507823faa942b2fbf23",
        "type": 1,
        "operation": "2022-02-13 14:22:46 尤圣昕教师布置了一份高中物理作业",
        "realname": "尤圣昕"
      }, {
        "operation_time": "2022-01-28 13:51:06.000",
        "id": "371066180",
        "type": 2,
        "operation": "2022-01-28 13:51:06 夏文斌教师上传了一份资源",
        "realname": "夏文斌"
      }, {
        "operation_time": "2021-11-07 15:04:29.000",
        "id": "242669940",
        "type": 2,
        "operation": "2021-11-07 15:04:29 陈小红教师上传了一份资源",
        "realname": "陈小红"
      }, {
        "operation_time": "2021-11-07 14:38:53.000",
        "id": "133133497",
        "type": 2,
        "operation": "2021-11-07 14:38:53 陈小红教师上传了一份资源",
        "realname": "陈小红"
      }, {
        "operation_time": "2021-11-07 14:08:09.000",
        "id": "117289690",
        "type": 2,
        "operation": "2021-11-07 14:08:09 陈小红教师上传了一份资源",
        "realname": "陈小红"
      }, {
        "operation_time": "2021-11-07 13:46:13.000",
        "id": "478973899",
        "type": 2,
        "operation": "2021-11-07 13:46:13 陈小红教师上传了一份资源",
        "realname": "陈小红"
      }, {
        "operation_time": "2021-02-25 23:47:25.000",
        "id": "3039714a48df411eb28965d9b2945fb2",
        "type": 2,
        "operation": "2021-02-25 15:47:25 陈  露教师上传了一份资源",
        "realname": "陈  露"
      }]
    }
  },
  methods: {
    async getRegionSchoolInformation() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        districtCode: _this.areaParams.districtCode,
        regionId: _this.regionId
      };
      let res = await getRegionSchoolInfomation(params);
      _this.schoolNum = res[0].schoolNum;
      _this.classNum = res[0].classNum;
      _this.studentNum = res[0].stuNum;
      _this.teacherNum = res[0].teaNum;
    },
    /**
     * 根据区域编码获取地理位置数据
     */
    async getBaseRegionCoordinateByRegionCode(data) {
      let _this = this;
      let params = {
        regionCode: data,
      };
      let res = await queryBaseRegionCoordinateByRegionCode(params);
      return JSON.parse(res.coordinateCode);
    },
    /**
     * 初始化区域地图
     */
    initDistrictsMap(data) {
      let _this = this;
      _this.districtData = data;
      this.$echarts.registerMap(_this.areaName, _this.districtData); //注册
      //获取市级下区域的经纬度
      let mapFeatures = this.$echarts.getMap(_this.areaName).geoJson.features;
      mapFeatures.forEach(function (v) {
        // 地区名称
        let name = v.properties.name;
        // 地区经纬度
        _this.geoCoordMap[name] = v.properties.centroid;
      });
      _this.initMap(_this.areaName);
    },
    /**
 * 渲染地图
 */
    initMap(provinceName) {
      let _this = this;
      //配置样式
      var optionMap = {
        geo: {
          map: provinceName,
          zoom: 1,
          roam: false,
          top: "5%",
          left: 0,
          right: '2%',
          label: {
            normal: {
              show: false,
              textStyle: {
                color: "#fff",
              },
            },
            emphasis: {
              show: false,
              color: "#fff",
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#24CFF4",
              borderColor: "#53D9FF",
              borderWidth: 1.3,
              shadowBlur: 15,
              shadowColor: "rgb(58,115,192)",
              shadowOffsetX: 7,
              shadowOffsetY: 6,
            },
            emphasis: {
              areaColor: "#8dd7fc",
              borderWidth: 1.6,
              shadowBlur: 25,
            },
          },
        },
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            geoIndex: 0,
            data: _this.convertData(_this.data),
            symbolSize: 12,
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            animation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "top",
                show: true,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                color: "#f4e925",
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            zlevel: 1,
          },
          {
            name: "categoryChina",
            type: "map",
            geoIndex: 0,
            data: _this.data,
          },
        ],
      };
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let dom = document.getElementById("region_map");
      //得到echarts的实例对象
      _this.map = _this.$echarts.init(dom);
      _this.map.setOption(optionMap);
      //点击弹出区地图
      _this.map.on("click", function (params) {
        if (params.seriesType == "effectScatter" && params.name == '高新智慧学校') {
          window.open("https://preschool.iclass30.com/schoolresource", "_blank")
        } else {
          return
        }
      });
    },
    /**
     * 各地区经纬度，数值data
     */
    convertData(data) {
      let _this = this;
      var res = [];
      res.push({
        code: "340104",
        name: "高新智慧学校",
        value: [117.056602, 31.871074, 0]
      })
      res.push({
        code: "340104",
        name: "新华小学",
        value: [117.026139, 31.992767, 0]
      })
      res.push({
        code: "340104",
        name: "第七中学",
        value: [117.002445, 31.862462, 0]
      })
      res.push({
        code: "340104",
        name: "实验第二中学",
        value: [117.2064856, 31.8535432, 0]
      })
      res.push({
        code: "340104",
        name: "高新区实验中学",
        value: [117.1824856, 31.8305432, 0]
      })
      res.push({
        code: "340104",
        name: "实验中学",
        value: [117.0035856, 31.8305432, 0]
      })
      res.push({
        code: "340104",
        name: "华维文澜中学",
        value: [117.0066128, 31.921074, 0]
      })
      res.push({
        code: "340104",
        name: "北京路中学",
        value: [117.0166028, 31.951274, 0]
      })
      res.push({
        code: "340104",
        name: "明德小学",
        value: [117.227239, 31.820587, 0]
      })
      res.push({
        code: "340104",
        name: "高新第四中学",
        value: [117.13897, 31.852044, 0]
      })
      res.push({
        code: "340104",
        name: "振新小学",
        value: [117.130074, 31.835302, 0]
      })
      res.push({
        code: "340104",
        name: "琥珀中学",
        value: [116.900092, 31.957609, 0]
      })
      res.push({
        code: "340104",
        name: "兴圆中学",
        value: [117.241800, 31.761128, 0]
      })
      return res;
    },
    /**
 * 通过区域code获取下级区域数据
 */
    async getNextRegionSchoolInformation() {
      let _this = this;
      let params = {
        provinceCode: _this.areaParams.provinceCode,
        cityCode: _this.areaParams.cityCode,
        // districtCode: _this.areaParams.districtCode,
        regionId: _this.regionId
      };
      let res = await getNextRegionSchoolInfomation(params);
      _this.data = _this.getAreaMapData(res);
      //根据区域编码获取地理位置数据
      let data = await _this.getBaseRegionCoordinateByRegionCode(
        _this.areaParams.districtCode
      );
      _this.initDistrictsMap(data);
    },
    /**
 * 获取地图数据
 */
    getAreaMapData(list) {
      let data = [];
      for (let i = 0; i < list.length; i++) {
        let areaObj = {};
        areaObj.name =
          this.type == "province" ? list[i].cityName : list[i].districtName;
        areaObj.code =
          this.type == "province" ? list[i].cityCode : list[i].districtCode;
        areaObj.value = list[i].schoolNum;
        areaObj.districtDataList = [
          {
            name: "学校总数",
            value: list[i].schoolNum,
          },
          {
            name: "班级总数",
            value: list[i].classNum,
          },
          {
            name: "教师总数",
            value: list[i].teaNum,
          },
          {
            name: "学生总数",
            value: list[i].stuNum,
          },
        ];
        data.push(areaObj);
      }
      return data;
    },
    init() {
      let boxdom = document.getElementById('box');
      if (!boxdom) {
        return
      }
      let aDiv = boxdom.childNodes
      for (var i = 0; i < aDiv.length; i++) {
        aDiv[i].style.background =
          "url(img/" + (i + 1) + ".jpg) center/cover";
        aDiv[i].style.transform =
          "rotateY(" + i * 45 + "deg) translate3d(0,0,350px)";
        aDiv[i].style.transition =
          "transform 1s " + (aDiv.length - i) * 0.2 + "s";
      }
      setTimeout(() => {
        this.timer = setInterval(this.dynamicScroll, 30);
      }, 200)
    },
    dynamicScroll() {
      let boxdom = document.getElementById('box');
      let transform = boxdom.style.transform
      let i = 0;
      try {
        let startIndex = transform.indexOf("rotateY(") + 8;
        let endIndex = transform.indexOf(")", startIndex);
        let value = transform.substring(startIndex, endIndex);
        i = value.substring(0, value.length - 3)
        if (i) {
          i = Number(i)
        }
      } catch { }
      let index = i + 1
      boxdom.style.transform = `rotateX(-17deg) rotateY(${index}deg)`
    },
  },
  async mounted() {
    let _this = this;
    //通过区域code获取区域数据
    _this.getRegionSchoolInformation();
    // //通过区域code获取下级区域数据
    _this.getNextRegionSchoolInformation();
    this.init();
  }
}
</script>
<style lang='scss' scoped>
.region-map {
  width: 100%;
  height: 80%;
  display: flex;
  // padding: 0 15px;
  // background: rgba(6,17,52,0.8);
  // border: 1px solid #053882;
  position: relative;
  margin-bottom: 20px;

  .map {
    width: 45%;
    height: 100%;
    overflow: hidden;

    .map-echarts {
      // margin-left: -6%;
      width: 100%;
      height: 100%;
      // transform: rotate(-5deg);
    }
  }

  .active-school-rank-top {
    position: relative;
    text-align: center;
    margin-bottom: 20px;
    width: 55%;

    .title {
      display: inline-block;
      padding: 9px 22px 8px 17px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #D0E7FE;
      line-height: 18px;
      position: relative;
      left: 0;
      z-index: 102;
    }

    .title-bg {
      // width: auto;
      height: 38px;
      position: absolute;
      top: 0;
      left: 55%;
      transform: translateX(-50%);
    }

    .number {
      background-image: url("~@/assets/images/numbg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center bottom;
      font-size: 100%;
      font-family: DigifaceWide;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 100%;
      padding: 5px;
      margin: 5px 3px;
    }

    /* 无限滚动垂直 */
    @keyframes infinitevertical {
      0% {
        transform: translateY(0%);
      }

      100% {
        transform: translateY(-25%);
      }
    }

    .dynamicList {
      overflow: hidden;
      height: 400px;
padding-left: 10px;
      .list {
        color: #FFFFFF;

        position: relative;
        animation: infinitevertical 5s linear infinite;

        &:hover {
          animation-play-state: paused;
        }

        .item {
          width: fit-content;
          height: 28px;
          background: rgba(43, 127, 255, 0.2);
          box-shadow: 0px 0px 1px 0px rgba(18, 99, 255, 0.15);
          border-radius: 17px;
          line-height: 28px;
          margin: 15px;
          padding: 0 10px;

          .red-text {
            color: #0EFCFF;
          }
        }
      }
    }
  }
}
</style>